module.exports = __webpack_public_path__ + "static/img/rectangle.2db5277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rectangle.png
// module id = UkQT
// module chunks = 1